import React, { useState, useEffect } from "react";
import MasterTable from "../common/MasterTable";
import VendorModal from "../vendor/VendorModal";
import { axiosPostApi } from "../../helpers/interceptorServices";
import { apiList } from "../../helpers/apiList";
import CustomAlert from "../../helpers/CustomAlert";
import { toast } from "react-toastify";
import Loader from "../Loader/Loader";
import VendorAuditModal from "./VendorAuditModal";
import VendorFilterModal from "./VendorFilterModal";
import VendorSequenceModal from "./VendorSequenceModal";

const defaultFilterData = {
  vendorName: "",
  status: [],
  smsType: null,
  fromDate: "",
  toDate: "",
};

const Vendor = () => {
  const pageSize = 10;
  const loggedInUserName = sessionStorage.getItem("username");
  const [noData, setNoData] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState({});
  const [vendorData, setVendorData] = useState([]);
  const [modalAction, setModalAction] = useState("");
  const [pageDetails, setPageDetails] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [auditData, setAuditData] = useState("");
  const [filterData, setFilterData] = useState(defaultFilterData);
  const [isModalOpenFilter, setIsModalOpenFilter] = useState(false);
  const [isModalOpenAudit, setIsModalOpenAudit] = useState(false);

  const [showSequenceModal, setShowSequenceModal] = useState(false);
  const [selectedVendor, setSelectedVendor] = useState(null);

  const handleReset = () => {
    setFilterData(defaultFilterData);
    // fetchVendorData(1, defaultFilterData);
  };

  const openModalFilter = () => {
    setIsModalOpenFilter(true);
  };

  const closeModalFilter = () => {
    setIsModalOpenFilter(false);
  };

  const openModalAudit = () => {
    setIsModalOpenAudit(true);
  };

  const closeModalAudit = () => {
    setIsModalOpenAudit(false);
  };

  const handleAuditData = (data) => {
    let venData = vendorData.find((item) => item?.id === data?.id);
    console.log("venData", venData);
    fetchUserAudit(venData);
  };

  const fetchUserAudit = async (venData) => {
    setLoading(true);
    try {
      const requestBody = {
        username: loggedInUserName,
        userCode: venData.vendorId,
      };

      const response = await axiosPostApi(
        `${apiList.VENDOR_AUDIT_DATA}`,
        requestBody
      );
      console.log("FetchVendorAudit", response);

      if (
        response?.data?.status === true &&
        response?.data?.respCode === "00"
      ) {
        setAuditData(response?.data?.data?.auditDetails);
        openModalAudit(auditData);
        setLoading(false);
      } else {
        setLoading(false);
        CustomAlert({
          title: "Error",
          text: response?.data?.message || "Failed to fetch audit data.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      }
    } catch (error) {
      CustomAlert({
        title: "Error",
        text: "An error occurred while fetching the data. Please try again later.",
        icon: "error",
        confirmButtonText: "Retry",
      });
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchVendorData(1, filterData);
  }, []);

  const fetchVendorData = (currentPage, filters = filterData) => {
    const payload = {
      username: loggedInUserName,
      vendorId: "",
      vendorName: filters.vendorName || "",
      smsType: filters.smsType?.value || "",
      fromDate: formatDate(filters.fromDate),
      toDate: formatDate(filters.toDate),
      status:
        filters.status.length > 0
          ? filters.status
          : ["Active", "Block", "In-Active", "DE-ACTIVE"],
    };

    setLoading(true);

    axiosPostApi(
      `${apiList.FETCH_VENDOR_DATA}?&pageSize=${pageSize}&pageNo=${currentPage}`,
      payload
    )
      .then((response) => {
        if (
          response?.data?.status === true &&
          response?.data?.respCode === "00"
        ) {
          setPageDetails(response?.data?.pageDetails);
          const modifiedData = modifyStructure(response?.data?.data);
          setVendorData(modifiedData);

          if (modifiedData?.length === 0) {
            setNoData(true);
          } else {
            setNoData(false);
          }
        } else {
          setNoData(true);
          setVendorData([]);
        }
      })
      .catch((error) => {
        CustomAlert({
          title: "Error",
          text: "An error occurred while fetching the data. Please try again later.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const formatDate = (dateStr) => {
    if (!dateStr) return "";
    const [year, month, day] = dateStr.split("-");
    return `${day}-${month}-${year}`;
  };

  const modifyStructure = (response) => {
    return response?.map((item, index) => ({
      ...item,
      id: index + 1,
    }));
  };

  const handleAuthorization = (authData) => {
    const loggedInUserName = sessionStorage.getItem("username");
    const requestBody = {
      ...authData,
      username: loggedInUserName,
      status: "1",
    };

    axiosPostApi(apiList.AUTH_VENDOR_DATA, requestBody)
      .then((response) => {
        if (response?.status === 200 && response?.data?.respCode === "00") {
          toast.success("Vendor Authorized successfully!");
          fetchVendorData(1, filterData);
        } else {
          CustomAlert({
            title: "Failed to Authorized vendor",
            text:
              response.data?.message ||
              "Invalid credentials. Please try again!",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        console.error("Error Authorized vendor", error);
        toast.error("Failed to Authorized vendor.");
      });
  };

  const vendorHeaders = [
    "Status",
    "Vendor Name",
    "Vendor Code",
    "SMS Type",
    "Vendor Address",
    "SPOC Name",
    "SPOC Contact No.",
    "Bank Name",
    "Account No.",
    "IFSC Code",
    "SMS Rate",
    "RCS Rate",
  ];

  const vendorHeaderToKeyMap = {
    Status: "authStatus",
    "Vendor Name": "vendorName",
    "Vendor Code": "vendorCode",
    "SMS Type": "smsType",
    "Vendor Address": "vendorAddress",
    "SPOC Name": "spocName",
    "SPOC Contact No.": "spocContactNo",
    "Account No.": "accountNo",
    "IFSC Code": "ifscCode",
    "Bank Name": "bankName",
    "SMS Rate": "rate",
    "RCS Rate": "rcsRate",
  };

  const handleCloseModal = () => {
    setShowModal(false);
    setEditData({});
    setModalAction("");
  };

  const handlerVendor = (data, actionType = "view") => {
    if (actionType === "sequence") {
      const venData = vendorData.find((item) => item?.id === data?.id);
      setSelectedVendor(venData);
      setShowSequenceModal(true);
      return;
    }
    setModalAction(actionType);

    if (actionType === "add") {
      setEditData({});
      setShowModal(true);
    } else {
      let venData = vendorData.find((item) => item?.id === data?.id);
      if (venData) {
        setEditData(venData);
        setShowModal(true);
      }
    }
  };

  const pageSizeCount = pageDetails === null ? 0 : pageDetails.pageSize;
  const totalRecord = pageDetails === null ? 0 : pageDetails.totalRecords;

  return (
    <div>
      {loading ? (
        <Loader />
      ) : (
        <>
          <MasterTable
            headers={vendorHeaders}
            data={vendorData}
            handleAction={handlerVendor}
            filterFields={["vendorName"]}
            entityType="Vendor"
            headerToKeyMap={vendorHeaderToKeyMap}
            loading={loading}
            noData={noData}
            handleAuth={handleAuthorization}
            pageDetails={pageDetails}
            currentPage={currentPage}
            pageSize={pageSizeCount}
            totalRecord={totalRecord}
            fetchNextData={fetchVendorData}
            setCurrentPage={setCurrentPage}
            handleAuditData={handleAuditData}
            openModalFilter={openModalFilter}
            handleReset={handleReset}
            filterData={filterData}
            fetchData={() => fetchVendorData(1, defaultFilterData)}
          />
          <VendorModal
            show={showModal}
            handleClose={handleCloseModal}
            editData={editData}
            action={modalAction}
            fetchVendorData={() => fetchVendorData(1, filterData)}
          />
          {isModalOpenFilter ? (
            <VendorFilterModal
              show={isModalOpenFilter}
              handleClose={closeModalFilter}
              setVendorData={setVendorData}
              setPageDetails={setPageDetails}
              setNoData={setNoData}
              currentPage={currentPage}
              pageSize={pageSize}
              filterData={filterData}
              setFilterData={setFilterData}
              handleReset={handleReset}
            />
          ) : null}
          {isModalOpenAudit ? (
            <VendorAuditModal
              show={isModalOpenAudit}
              handleClose={closeModalAudit}
              auditData={auditData}
            />
          ) : null}

          <VendorSequenceModal
            show={showSequenceModal}
            handleClose={() => setShowSequenceModal(false)}
            vendor={selectedVendor}
            vendorData={vendorData}
            onSave={() => {
              setShowSequenceModal(false);
              fetchVendorData(1, filterData);
            }}
          />
        </>
      )}
    </div>
  );
};

export default Vendor;
